var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11.5H12C10.6193 11.5 9.5 12.6193 9.5 14V23C9.5 24.3807 10.6193 25.5 12 25.5H24C25.3807 25.5 26.5 24.3807 26.5 23V14C26.5 12.6193 25.3807 11.5 24 11.5ZM12 10C9.79086 10 8 11.7909 8 14V23C8 25.2091 9.79086 27 12 27H24C26.2091 27 28 25.2091 28 23V14C28 11.7909 26.2091 10 24 10H12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.25C14.4142 8.25 14.75 8.58579 14.75 9L14.75 10C14.75 10.4142 14.4142 10.75 14 10.75C13.5858 10.75 13.25 10.4142 13.25 10L13.25 9C13.25 8.58579 13.5858 8.25 14 8.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.25C22.4142 8.25 22.75 8.58579 22.75 9L22.75 10C22.75 10.4142 22.4142 10.75 22 10.75C21.5858 10.75 21.25 10.4142 21.25 10L21.25 9C21.25 8.58579 21.5858 8.25 22 8.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2105 14H13.7895C13.3579 14 13 14.34 13 14.75C13 15.16 13.3579 15.5 13.7895 15.5H22.2105C22.6421 15.5 23 15.16 23 14.75C23 14.34 22.6421 14 22.2105 14Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.21c35d77.svg";
export { ForwardRef as ReactComponent };